class BaseLang {
}
export {
  BaseLang as B
};
